import { useIntl } from 'react-intl'
import { connect } from 'react-redux'

import { EmptyArray, take } from 'lib/array/arrayUtils'
import FilterChip from 'LuxKit/Chips/FilterChip'

interface Props {
  popularHolidayTypes?: Array<string>
  availableHolidayTypesCount: number
  isToggled: (popularHolidayType: string) => boolean
  maxVisible?: number
  onSeeMore?: () => void
  onToggle: (popularHolidayType: string) => void
}

function PopularHolidayTypesFilterToggles({
  popularHolidayTypes = EmptyArray,
  availableHolidayTypesCount,
  isToggled,
  maxVisible = 6,
  onSeeMore,
  onToggle,
}: Props) {
  const intl = useIntl()
  const showSeeMore = !!onSeeMore && (popularHolidayTypes.length > maxVisible || popularHolidayTypes.length < availableHolidayTypesCount)

  return (
    <>
      {take(popularHolidayTypes, maxVisible).map(popularHolidayType =>
        <FilterChip
          size="medium"
          key={popularHolidayType}
          selected={isToggled(popularHolidayType)}
          onClick={() => onToggle(popularHolidayType)}
        >
          {popularHolidayType}
        </FilterChip>)}
      {showSeeMore &&
        <FilterChip size="medium" onClick={onSeeMore}>
          {intl.formatMessage({
            id: 'LS-ocqk0yQ_4pf2yM378',
            defaultMessage: 'See more...',
            description: 'Chip label to expand and see more popular holiday type filters',
          })}
        </FilterChip>}
    </>
  )
}

function mapStateToProps(state: App.State) {
  return {
    popularHolidayTypes: state.destination.hotelPopularHolidayTypes,
  }
}

export default connect(mapStateToProps)(PopularHolidayTypesFilterToggles)
